import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { scrollToContent, OVERLAY_TOP } from "../../../utils/layout";

function XframeContainer(props) {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [printButton, setPrintButton] = useState(false);

  const printResource = () => {
    const printWindow = window.open(props.file,'_blank','width=1000,height=600')
    printWindow.print()
  }

  useEffect(() => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  }, [props.orientation]);

  useEffect(() => {
    scrollToContent();
  },[])

  useEffect(() => {
    if(props.filetype != 1 ){
      if(props.file){
        setPrintButton(true)
      }
    }
  },[])

  return (
    <>
      <title>{props.name}</title>
      {printButton && <Button variant="warning" style={{position:'absolute',right:50,top:OVERLAY_TOP,zIndex:10}} onClick={() => printResource()} >Print</Button>}
      <iframe src={props.url} width={width} height={height}></iframe>
    </>
  );
}

export default XframeContainer;
